import React, {useState} from 'react';
import axios from '../Common/axios';
import { Modal, Spin } from "antd";
import {getGridTableHeight} from '../Common/util';
import {postSaveMeasureStats} from '../../pages/Common/api';
import { SearchOutlined } from '@ant-design/icons';
import PlanTableRs from './PlanTableRs';

/** -------------------------------------------------------------------------- **/
function PlanRs({companyCode, reportId, planList, setIsDataChange, spinflag}) {

    // Table 선택박스 설정
    const [selectedRowKeys, setSelectedRowKeys] = useState([]); 
    const onSelectChange = (newSelectedRowKeys) => {
        //console.log('selectedRowKeys changed: ', newSelectedRowKeys);
        setSelectedRowKeys(newSelectedRowKeys);
    };
    const titleName="이행점검 결과";
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    //----------------------------------------------------------------------------------------
    // 저장 클릭 시
    const onClickSaveHandler = (saveData) => {

        // alert("아직 미완성 입니다.");
        // return;
        // 변경건이 있으면 추가
        if(saveData.length > 0) {
            saveModifyVaResultData(saveData);
        } else {
            Modal.info({title:titleName, content:"변경된 데이타가 없습니다.", okText:"Close"});
        }

    }

    // 이행결과 수정 API
    const saveModifyVaResultData = (saveData) => {
        setIsDataChange(false);
        let saveDataLen = saveData.length;

        // for(let i=0; i < saveDataLen; i++){
        //     if(saveData[i].remark==""){
        //         alert("사유를 반드시 적어주세요!");
        //         return;
        //     }
        // }
       
        axios.post(postSaveMeasureStats()
                        , {reportId : reportId, resultType : 'C', statisticCompare : saveData}
                        , {logCompany : companyCode, logParam : reportId})
        .then((response) => {
            if(response.data.status === 'success') {
                Modal.info({title:titleName, content:response.data.message, okText:"Close", onOk() {
                    // 선택정보 초기화
                    setIsDataChange(true);
                }});
            } else {
                Modal.info({title:titleName, content:response.data.message, okText:"Close"});
            }
        }).catch((error) => {
            Modal.error({title:titleName, content:error.message, okText:"Close"});
        });
    };

    //----------------------------------------------------------------------------------------
    return (
        <Spin size={"large"}  tip={"Loading..."} spinning={spinflag}>
            <div id="divTabs1" className="section" style={{height:'100%', overflowY:'auto'}}>
                <div className="sub_title">
                        {'■ 이행점검 결과'}
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <span style={{color:'#0378c7', fontSize:'11px', fontWeight:'normal'}}>※ [일괄적용]시 수정하고자 하는 항목에만 값을 입력해 주세요.</span>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <span style={{color:'#0378c7', fontSize:'11px', fontWeight:'normal'}}>※ <SearchOutlined />필터 적용 시, [저장]후 다음 작업 진행시 필터해제 후 진행해 주세요.</span>
                </div>
                <div style={{padding: '0px 0px'}}>
                    <PlanTableRs
                        data={planList} 
                        columnData={[]}
                        rowKey="asset_cd"
                        onClickSaveHandler={onClickSaveHandler}
                        rowSelection={rowSelection}
                        selectedRowKeys={selectedRowKeys}
                    />
                </div>
            </div>
        </Spin>
    );
}
export default PlanRs;